require('./bootstrap');

window.Vue = require('vue')

import VueAxios from 'vue-axios'
import axios from 'axios';
import AxiosPlugin from 'vue-axios-cors'
import Skeleton from 'vue-loading-skeleton'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/onlinereg-app/MainComponent.vue'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import loading from 'vuejs-loading-screen'
import router from './router'
import VueTouchKeyboard from "vue-touch-keyboard"
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"

Vue.use(AxiosPlugin)
Vue.use(VueSweetalert2)
Vue.use(VueAxios, axios)
Vue.use(Skeleton)
Vue.use(Vuex)
Vue.use(require('vue-moment'));
Vue.use(VueLoading)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(loading, {
    bg: '#41b883ad',
    icon: 'fa fa-spinner',
    size: 3,
    icon_color: 'white',
})
Vue.use(VueTouchKeyboard)

window.moment = require('moment');

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm')
    }
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
    }
})

Vue.filter('formatDateTextMonth', function (value) {
    if (value) {
        let month = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ]
        let month_name = new Date(value).getMonth()
        return moment(String(value)).format('DD ') + month[month_name] + moment(String(value)).format(' YYYY')
    }
})

Vue.mixin({
    methods: {
        inArray(search, array) {
            let exist = false
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        },
        inObject(search, object) {
            let exist = false
            let array = Object.values(object)
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        }
    }
})

const store = new Vuex.Store({
    state: {
        auth_status: false,
        margin: 0,
        access_token: '',
        user: null,
        sso_access_token: '',
        sso_user: [],
        sso_user_role: [],
        posyandu: null,
        sso_code: null
    },
    created() {
        this.getAuth()
    },
    mutations: {
        loadApp() {
            const app = new Vue(Vue.util.extend({ store, router }, App)).$mount('#app')
        },
        getAuth(state) {
            state.access_token = localStorage.getItem('access_token')
            state.user = JSON.parse(localStorage.getItem('user'))
            state.posyandu = JSON.parse(localStorage.getItem('posyandu'))
        },
        getAuthSSO(state) {
            state.sso_access_token = localStorage.getItem('sso_access_token')
            state.sso_user = localStorage.getItem('sso_user') != 'undefined' && localStorage.getItem('sso_user') != '' ? JSON.parse(localStorage.getItem('sso_user')) : null
            state.sso_user_role = localStorage.getItem('sso_user_role') != 'undefined' && localStorage.getItem('sso_user_role') != '' ? JSON.parse(localStorage.getItem('sso_user_role')) : null
        }
    }
})

store.commit('loadApp')
